import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=10db09fe&scoped=true&"
import script from "./Text.vue?vue&type=script&lang=ts&"
export * from "./Text.vue?vue&type=script&lang=ts&"
import style0 from "./Text.vue?vue&type=style&index=0&id=10db09fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db09fe",
  null
  
)

export default component.exports